import { useCallback } from 'react';

import { Switch } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

export default function ToggleFormatter({ info }) {
  const { row, field, value } = getInfo(info)
  const { events: { handleUpdateEntry } } = useGrid()

  const handleUpdateActive = useCallback(() => {
    const { id, isSuperAdmin, isManagerAdmin, is_admin } = row
    handleUpdateEntry({ id, isSuperAdmin, isManagerAdmin, is_admin, [field]: !value })
  }, [handleUpdateEntry, field, row, value])

  return <Switch value={value} onChange={handleUpdateActive} />
}
